import React from 'react';

import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import {useCurrentUser} from 'app/current-user/api';
import {useCreateProduct, useProducts} from 'app/market/api';
import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {TeamProductItem} from 'app/teams/components/TeamDetailPage/components/TeamProductItem';
import {gt} from 'app/utils/i18n';

import type {ListItemProps} from 'app/teams/components/TeamDetailPage/components/TeamListItem';
import type {ProductSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
};

export const TeamProductsSubPage = ({team}: Props) => {
  const [createProduct] = useCreateProduct();

  const {data: currentUser} = useCurrentUser(undefined, {
    refetchOnMountOrArgChange: false,
  });

  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="ml-auto col-auto align-items-center d-flex">
            <button
              className="btn btn-light"
              disabled={currentUser?.is_super_manager !== true}
              onClick={() =>
                createProduct({team: team.url, html_url: team.html_url})
              }
            >
              <i className="fas fa-plus-circle mr-1" /> {gt('Add Product')}
            </button>
          </div>
        </TeamPageFilterBarStructure>
      ) : null}

      <GenericPaginatedListRTK
        ItemComponent={ProductListItem}
        useQuery={useProducts}
        WrapperComponent={ContainerDiv}
        paramsBuilder={({location: {query}}) => ({
          team: team.url,
          ordering: query.ordering,
        })}
        noItemsMessage={(perms, NoResultsMessage) => (
          <NoResultsMessage head={gt('No products for this team')}>
            <>
              <p>
                {gt(
                  'Products are used to share the procedures, processes and policies in a team from one account to another.'
                )}
              </p>

              <LazyTooltip
                hide={currentUser?.is_super_manager === true}
                tooltip={gt('You must be super manager')}
              >
                <div>
                  <button
                    className="btn btn-outline-primary"
                    disabled={currentUser?.is_super_manager !== true}
                    onClick={() =>
                      createProduct({team: team.url, html_url: team.html_url})
                    }
                  >
                    <i className="fas fa-plus-circle mr-1" />
                    {gt('Add Product')}
                  </button>
                </div>
              </LazyTooltip>
            </>
          </NoResultsMessage>
        )}
      />
    </div>
  );
};

const ProductListItem = ({object}: ListItemProps<ProductSerializedType>) => (
  <TeamProductItem product={object} />
);

const ContainerDiv = styled.div.attrs({className: 'container-fluid'})``;
